import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-[hsl(var(--surface))] border-y border-[hsl(var(--line))]"
    >
      <div className="container-edge py-20 md:py-28">
        <div className="max-w-4xl">
          <div className="eyebrow" data-testid="about-eyebrow">About Eve</div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="mt-5 font-display text-[hsl(var(--ink))] text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]"
            data-testid="about-heading"
          >
            Born in Mexico. Built on language.
            <span className="block italic text-[hsl(var(--accent))]">Driven by community.</span>
          </motion.h2>

          <div className="mt-8 space-y-5 text-[hsl(var(--text-muted))] text-base md:text-lg leading-relaxed max-w-2xl">
            <p data-testid="about-para-1">
              Spanish is my first language and English is my second home.
              Interpreting has been part of my entire life — from helping family
              navigate appointments to standing alongside professionals in some
              of the most important conversations of their clients' lives.
            </p>
            <p data-testid="about-para-2">
              Along the way I realized the need wasn't only personal — it was
              everywhere in our community. Hospitals, courtrooms, immigration
              offices, and businesses are all looking for someone who can listen
              with care and speak with precision in both languages.
            </p>
            <p data-testid="about-para-3">
              Today, EG Spanish Interpreting brings together a small, carefully
              vetted team of qualified bilingual interpreters who share that
              same commitment to accuracy, empathy, and complete
              confidentiality — so that no matter the setting, every voice is
              heard exactly as it was meant to be.
            </p>
          </div>

          <div className="mt-10 pl-6 border-l-2 border-[hsl(var(--accent))]">
            <Quote size={20} className="text-[hsl(var(--accent))]" />
            <p
              data-testid="about-quote"
              className="mt-3 font-display text-xl md:text-2xl text-[hsl(var(--ink))] italic leading-snug max-w-2xl"
            >
              "I treat every word like it matters — because for the person
              speaking it, it always does."
            </p>
            <div className="mt-4 text-sm uppercase tracking-[0.22em] text-[hsl(var(--text-muted))]">
              Eve Gomez · CEO / Founder, EG Spanish Interpreting
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
